import { Container, Sprite, Texture } from 'pixi.js';
import Reel from './Reel';
import Lines from './Lines';
import StickyWilds from './StickyWilds';
import CoeffsView from './CoeffsView';
import { Tween, Easing } from '@tweenjs/tween.js';
import { EVENTS } from '../lib/constants';
import HELPERS from '../lib/globals/helpers/Helpers';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';

class Reels extends Container {
  reels = null;
  config = null;
  bg = null;
  maskGraphics = null;
  fg = null;
  lines = null;
  finishedReels = 0;
  currentItems = null;
  baiting = [];
  rotating = false;
  fastS = false;
  stickyWilds = null;
  emptyreel = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 0, 1],
    [2, 3, 4],
  ];
  coeffsView = null;

  constructor(cfg) {
    super();
    this.reels = [];
    this.config = cfg;
    this.borderActive = false;
    this.star_accelerate = false;

    if (this.config.animations !== undefined) {
      this.addBorders();
    }

    if (this.config.bg) {
      this.bg = Sprite.from(Texture.from(this.config.bg));
      this.addChild(this.bg);
    }
    for (let i = 0; i < this.config.width; i++) {
      var reel = new Reel(i, this.config, this.reelHandler.bind(this));
      reel.x = this.config.iconWidth * i - 3;
      this.addChild(reel);
      this.reels.push(reel);
    }
    this.lines = new Lines(
      cfg.linesConfig,
      this.linesHandler.bind(this),
      this.reels
    );
    if (this.config.reelsMask) {
      if (this.maskGraphics != null) {
        this.removeChild(this.maskGraphics);
      }
    }
    if (this.config.divider) {
      this.fg = new Sprite();
      for (let i = 0; i < this.config.width - 1; i++) {
        var divider = Sprite.from(Texture.from(this.config.divider));
        divider.x =
          (i + 1) * this.config.iconWidth -
          (this.config.iconWidth - this.config.iconRealWidth) / 2 -
          0.15 * (i + 1);
        this.fg.addChild(divider);
      }
      this.addChild(this.fg);
    }
    this.createbaitFrame();
    window.addEventListener('keydown', this.handleKeyDown.bind(this));
    window.addEventListener(
      EVENTS.SETTINGS_UPDATE,
      this.settingsChange.bind(this)
    );

    this.coeffsView = new CoeffsView(this.reels, this.lines);
    this.addChild(this.coeffsView);
  }

  createbaitFrame() {
    //LEFT FRAME
    this.frame_left = HELPERS.getAnimatedSprite({
      pattern: 'Flames_Side_Lit$.png',
      start: 0,
      end: 96,
      speed: 0.5,
      precision: 2,
      loop: true,
    });
    this.frame_left.rotation = 3.14159;

    this.frame_leftW = isMobile || isTablet ? 135 / 2 - 12 : 270 / 2 - 25;
    this.frame_leftH = isMobile || isTablet ? 371 / 2 - 15 : 743 / 2 - 30;
    // this.frame_left.x = this.config.iconWidth * 1 + this.frame_leftW;
    this.frame_left.x = 0;
    this.frame_left.y = this.frame_leftH;
    this.frame_left.anchor.set(0.5, 0.5);
    this.frame_left.alpha = 0;
    this.addChild(this.frame_left);
    //RIGHT FRAME
    this.frame_right = HELPERS.getAnimatedSprite({
      pattern: 'Flames_Side_Lit$.png',
      start: 0,
      end: 96,
      speed: 0.5,
      precision: 2,
      loop: true,
    });
    this.frame_rightW = isMobile || isTablet ? 135 / 2 - 12 : 270 / 2 - 25;
    this.frame_rightH = isMobile || isTablet ? 371 / 2 - 15 : 743 / 2 - 30;
    this.frame_right.x = 0;
    this.frame_right.y = this.frame_rightH;
    this.frame_right.anchor.set(0.5, 0.5);
    this.frame_right.alpha = 0;
    // this.frame_left.interactive = false;
    this.frame_right.eventMode = 'none';
    this.frame_left.eventMode = 'none';
    this.addChild(this.frame_right);
    if (GameConfigs.settings.game_animation) {
      this.frame_left.gotoAndPlay(0);
      this.frame_right.gotoAndPlay(0);
    } else {
      this.frame_left.gotoAndStop(0);
      this.frame_right.gotoAndStop(0);
    }
    if (this.coeffsView) {
      this.addChild(this.coeffsView);
    }
  }

  settingsChange(e) {
    if (e.detail.data.game_animation === undefined) return;
    if (e.detail.data.game_animation) {
      if (this.borderActive) {
        this.topBorder.gotoAndPlay(0);
        this.bottomBorder.gotoAndPlay(0);
      } else {
        this.topBorderPassive.gotoAndPlay(0);
        this.bottomBorderPassive.gotoAndPlay(0);
      }
    } else {
      this.topBorderPassive.gotoAndStop(0);
      this.bottomBorderPassive.gotoAndStop(0);
      this.topBorder.gotoAndStop(0);
      this.bottomBorder.gotoAndStop(0);
    }
  }

  handleKeyDown(event) {
    if (event.keyCode === 32) {
      if (this.rotating) {
        this.fastStop();
      }
    }
  }

  handleBodyClick(event) {
    this.fastStop();
  }

  addBorders() {
    this.sortableChildren = true;
    this.topBorder = HELPERS.getAnimatedSprite(this.config.animations.bg);
    this.bottomBorder = HELPERS.getAnimatedSprite(this.config.animations.bg);

    if (this.config.animations.spark !== undefined) {
      this.sparkles = HELPERS.getAnimatedSprite(this.config.animations.spark);
      this.sparkles.eventMode = 'none';
      this.sparkles.anchor.set(0.5);
      this.sparkles.position.x = 1144 / (isDesktop ? 2 : 4);
      this.sparkles.position.y = -110 / (isDesktop ? 1 : 2);
    }
    // this.topBorder.scale.y = 0;
    this.topBorderPassive = HELPERS.getAnimatedSprite(
      this.config.animations.bg2
    );
    this.bottomBorderPassive = HELPERS.getAnimatedSprite(
      this.config.animations.bg2
    );

    this.topBorder.zIndex = 10;
    this.topBorder.interactive = false;
    this.topBorderPassive.zIndex = 10;
    this.topBorderPassive.interactive = false;
    this.topBorder.eventMode = 'none';
    this.topBorderPassive.eventMode = 'none';
    this.bottomBorder.zIndex = 10;
    this.bottomBorder.interactive = false;
    this.bottomBorderPassive.zIndex = 10;
    this.bottomBorderPassive.interactive = false;
    this.bottomBorderPassive.eventMode = 'none';
    this.bottomBorder.eventMode = 'none';
    this.addChild(this.topBorder);
    this.addChild(this.bottomBorder);

    this.addChild(this.topBorderPassive);
    this.addChild(this.bottomBorderPassive);

    this.addChild(this.sparkles);

    if (this.coeffsView) {
      this.addChild(this.coeffsView);
    }
    this.topBorder.alpha = 0;
    this.bottomBorder.alpha = 0;

    this.topBorderPassive.alpha = 1;
    this.bottomBorderPassive.alpha = 1;
    let topX = isDesktop ? -81 : -81 / 2;
    let topY = isDesktop ? -83 : -83 / 2;

    let topActiveX = isDesktop ? -79 : -79 / 2;
    let topActiveY = isDesktop ? -83 : -83 / 2;

    let botX = isDesktop ? -85 : -85 / 2;
    let botY = isDesktop
      ? this.config.height * this.config.iconHeight - 88
      : this.config.height * this.config.iconHeight - 86 / 2;

    let botActiveX = isDesktop ? -87 : -87 / 2;
    let botActiveY = isDesktop
      ? this.config.height * this.config.iconHeight - 86
      : this.config.height * this.config.iconHeight - 86 / 2;

    //TODO get dynamic positions
    this.topBorder.position.set(topActiveX, topActiveY);
    this.bottomBorder.anchor.set(1, 0.5);
    this.bottomBorder.rotation = 3.14159;
    this.bottomBorder.position.set(botActiveX, botActiveY);
    this.topBorderPassive.position.set(topX, topY);

    this.topBorderPassive.scale.set(1.008, 1);
    this.topBorder.scale.set(1.008, 1);
    this.bottomBorderPassive.scale.set(1.008, 1);
    this.bottomBorder.scale.set(1.008, 1);

    this.bottomBorderPassive.anchor.set(1, 0.5);
    this.bottomBorderPassive.rotation = 3.14159;
    this.bottomBorderPassive.position.set(botX, botY);
    if (GameConfigs.settings.game_animation) {
      this.topBorderPassive.gotoAndPlay(0);
      this.bottomBorderPassive.gotoAndPlay(0);
      this.sparkles.gotoAndPlay(0);
    } else {
      this.topBorderPassive.gotoAndStop(0);
      this.bottomBorderPassive.gotoAndStop(0);
      this.sparkles.gotoAndStop(0);
    }
  }

  stopBorder() {
    this.sortableChildren = false;
    this.borderActive = false;
    this.topBorder.gotoAndStop(0);
    this.bottomBorder.gotoAndStop(0);
    if (GameConfigs.settings.game_animation) {
      this.topBorderPassive.gotoAndPlay(0);
      this.bottomBorderPassive.gotoAndPlay(0);
    } else {
      this.topBorderPassive.gotoAndStop(0);
      this.bottomBorderPassive.gotoAndStop(0);
    }
    this.topBorder.alpha = 0;
    this.bottomBorder.alpha = 0;
    this.topBorderPassive.alpha = 1;
    this.bottomBorderPassive.alpha = 1;
  }

  startBorder() {
    this.borderActive = true;
    this.sortableChildren = true;
    this.topBorderPassive.gotoAndStop(0);
    this.bottomBorderPassive.gotoAndStop(0);
    if (GameConfigs.settings.game_animation) {
      this.topBorder.gotoAndPlay(0);
      this.bottomBorder.gotoAndPlay(0);
    } else {
      this.topBorder.gotoAndStop(0);
      this.bottomBorder.gotoAndStop(0);
    }
    this.topBorder.alpha = 1;
    this.bottomBorder.alpha = 1;
    this.topBorderPassive.alpha = 0;
    this.bottomBorderPassive.alpha = 0;
  }

  resetBonus() {
    if (this.stickyWilds === null) {
      return;
    }
    for (let i = 0; i < this.reels.length; i++) {
      this.reels[i].restoreWilds();
    }
    this.lines.reset();
    new Tween(this.stickyWilds)
      .to({ alpha: 0 }, 250)
      .easing(Easing.Linear.None)
      .onComplete(() => {
        this.removeChild(this.stickyWilds);
        this.stickyWilds = null;
        this.lines.stickyWilds = null;
      })
      .start();
    let result = this.config.icons.filter((icon) => icon.isWild);
    result[0].animation.fg2Index = 0;
  }

  reelHandler(event) {
    this.finishedReels++;
    if (this.stickyWilds !== null) {
      //this.reels[event.id].replaceWilds(this.stickyWilds.wilds[event.id]);
    }
    if (this.finishedReels === this.reels.length) {
      this.star_accelerate = false;
      HELPERS.dispatchCustomEvent(EVENTS.BAIT, { bait: false });
      //   this.mask = null
      //   this.maskGraphics.alpha = 0;
      for (let i = 0; i < this.reels.length; i++) {
        this.reels[i].stopLoopItems();
      }

      if (this.currentItems.winlines.length <= 0) {
        this.stopBorder();
      }
      // this.lines.animate(this.currentItems.winlines);
      new Tween(this.frame_left)
        .to({ alpha: 0 }, 200)
        .easing(Easing.Linear.None)
        .start();
      new Tween(this.frame_right)
        .to({ alpha: 0 }, 200)
        .easing(Easing.Linear.None)
        .start();

      if (this.stickyWilds) {
        this.stickyWilds.setWilds(
          this.currentItems.wilds,
          this.currentItems.wildmultiplier
        );
        if (this.stickyWilds != null) {
          for (let i = 0; i < this.reels.length; i++) {
            this.reels[i].replaceWilds(this.stickyWilds.wilds[i]);
          }
        }
      }

      this.lines.animate(this.currentItems.winlines);
      // setTimeout(() => {
      this.rotating = false;
      HELPERS.dispatchCustomEvent(EVENTS.REEL_FINISHED, {});
      // }, 100);
    }

    if (!this.fastS) {
      if (event.id < this.baiting.length - 1) {
        if (this.baiting[event.id + 1]) {
          // for (let p = 0; p <= event.id; p++) {
          //   // this.reels[p].animateLoopItems(this.config.scatterCodes);
          // }
          window.sm.play({ name: 'bait_sfx' });
          if (!this.star_accelerate) {
            this.star_accelerate = true;
            HELPERS.dispatchCustomEvent(EVENTS.BAIT, { bait: true });
          }
          if (this.frame_left.alpha === 0) {
            this.frame_left.x = this.config.iconWidth * (event.id + 1) - 7;
            this.frame_right.x =
              this.config.iconWidth * (event.id + 1) +
              this.config.iconWidth -
              event.id * 4;
            new Tween(this.frame_left)
              .to({ alpha: 1 }, 50)
              .easing(Easing.Linear.None)
              .start();
            new Tween(this.frame_right)
              .to({ alpha: 1 }, 50)
              .easing(Easing.Linear.None)
              .start();
          } else {
            new Tween(this.frame_left)
              .to({ alpha: 0 }, 220)
              .easing(Easing.Linear.None)
              .onComplete(() => {
                this.frame_left.x = this.config.iconWidth * (event.id + 1) - 7;
                new Tween(this.frame_left)
                  .to({ alpha: 1 }, 220)
                  .easing(Easing.Linear.None)
                  .start();
                // window.sm.play({ name: "bait_sfx" });
              })
              .start();
            new Tween(this.frame_right)
              .to({ alpha: 0 }, 220)
              .easing(Easing.Linear.None)
              .onComplete(() => {
                this.frame_right.x =
                  this.config.iconWidth * (event.id + 1) +
                  this.config.iconWidth -
                  event.id * 4;
                new Tween(this.frame_right)
                  .to({ alpha: 1 }, 220)
                  .easing(Easing.Linear.None)
                  .start();
              })
              .start();
          }
        }
      }
    }
  }

  linesHandler(eventdata) {
    HELPERS.dispatchCustomEvent(eventdata.type, eventdata.line);
  }

  start() {
    if (this.rotating) {
      return;
    }
    HELPERS.dispatchCustomEvent(EVENTS.REEL_STARTED, {});
    this.fastS = false;
    this.rotating = true;
    this.lines.reset();
    this.baiting = [false, false, false, false, false];
    this.finishedReels = 0;
    this.startBorder();

    for (let i = 0; i < this.reels.length; i++) {
      // this.reels[i].start(100 * i);
      this.reels[i].start(50 * i);
    }
  }

  fastStop() {
    // console.log('fastStop')
    this.fastS = true;
    for (let i = 0; i < this.reels.length; i++) {
      this.reels[i].fastStop();
    }
  }

  emergencyStop() {
    if (this.currentItems === undefined || this.currentItems === null) {
      this.stop({
        reels: this.emptyreel,
        winlines: [],
      });
    } else {
      this.stop({ reels: this.currentItems.reels, winlines: [] });
    }
  }

  stop(items, isFast) {
    if (!this.fastS) {
      this.fastS = isFast;
    }
    if (items) {
      if (items && items.game_type === 'bonus') {
        if (this.stickyWilds === null) {
          this.stickyWilds = new StickyWilds(this.config);
          this.lines.stickyWilds = this.stickyWilds;
          this.addChild(this.stickyWilds);
          if (this.coeffsView) {
            this.addChild(this.coeffsView);
          }
        }
        let result = this.config.icons.filter((icon) => icon.isWild);
        result[0].animation.fg2Index = items.wildmultiplier - 1;
        //this.stickyWilds.setWilds(items.wilds, items.wildmultiplier);
      }
      //this.fastS
      var times = new Array(this.config.width).fill(0);
      var stopMode = new Array(this.config.width).fill(Reel.STOP_SIMPLE);
      let scattersCnt = 0;
      let timeout = 1;
      for (let i = 0; i < items.reels.length; i++) {
        if (scattersCnt > 1) {
          times[i] = this.config.baitTime * timeout;
          stopMode[i] = Reel.STOP_BAIT;
          this.baiting[i] = true;
          timeout = timeout + 3;
        }
        if (this.fastS) {
          stopMode = new Array(this.config.width).fill(Reel.STOP_FAST);
        }
        if (items.game_type === 'bonus') {
          if (this.fastS) {
            stopMode = new Array(this.config.width).fill(Reel.STOP_FAST);
          } else {
            stopMode = new Array(this.config.width).fill(Reel.STOP_SIMPLE);
          }
        }
        const element = items.reels[i];
        for (let t = 0; t < element.length; t++) {
          const itm = element[t];
          if (this.config.icons[itm].isScatter) {
            scattersCnt++;
          }
        }
      }
      this.currentItems = items;
      for (let i = 0; i < this.reels.length; i++) {
        this.reels[i].stop(
          items.reels[i],
          times[i],
          stopMode[i],
          items.game_type === 'bonus'
        );
      }
    }
  }

  animate(line) {
    for (let i = 0; i < this.reels.length; i++) {
      this.reels[i].animate(line);
    }
  }
}

export default Reels;
